<template>
  <div class="grid-x">
    <p class="cell small-12 info-exclusion-text" v-html="exclusionContent"></p>
  </div>
</template>

<script setup>
defineProps({
  exclusionContent: {
    type: String,
    default: '',
  },
});
</script>

<style lang="scss" brand="mcom" scoped>
p {
  word-break: break-word;
}
</style>

<style lang="scss" brand="bcom" scoped>
p {
  word-break: break-word;
}
.info-exclusion-text {
  color: #767676;
  font-size: rem-calc(12);
  font-weight: 400;
  line-height: rem-calc(20);
  letter-spacing: rem-calc(1.067);
  @media only screen and (max-width: rem-calc(600)) {
    padding-left: rem-calc(20px);
    padding-right: rem-calc(20px);
  }
}
</style>
